import { render, staticRenderFns } from "./CommunicationCreation.vue?vue&type=template&id=65e078eb&scoped=true&"
import script from "./CommunicationCreation.vue?vue&type=script&lang=js&"
export * from "./CommunicationCreation.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationCreation.vue?vue&type=style&index=0&id=65e078eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e078eb",
  null
  
)

export default component.exports